import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './ProductDetailSkeleton.css';

const ProductDetailSkeleton = () => {
  return (
    <Container className="my-4">
      <Row>
        <Col lg={6} md={6} className="mb-4">
          <div className="skeleton skeleton-image"></div>
          <div className="skeleton-thumbnails">
            <div className="skeleton skeleton-thumbnail"></div>
            <div className="skeleton skeleton-thumbnail"></div>
            <div className="skeleton skeleton-thumbnail"></div>
            <div className="skeleton skeleton-thumbnail"></div>
          </div>
        </Col>
        <Col lg={6} md={6}>
          <div className="skeleton skeleton-title"></div>
          <div className="skeleton skeleton-badge"></div>
          <div className="skeleton skeleton-price"></div>
          <div className="skeleton skeleton-text"></div>
          <div className="skeleton skeleton-text skeleton-text-short"></div>
          <div className="skeleton skeleton-button"></div>
        </Col>
      </Row>
    </Container>
  );
};

export default ProductDetailSkeleton;
